/** MessageBox.confirm */
import { Message, MessageBox } from 'element-ui'

export function handleConfirm (text, type) {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: type
    // center: true
  })
}
export function successMsg (text) {
  return Message.success(text)
}
export function warningMsg (text) {
  return Message.warning(text)
}
export function infoMsg (text) {
  return Message.info(text)
}

// msg:文案信息；duration：毫秒数；
export function Toast (msg, duration) {
  duration = isNaN(duration) ? 2000 : duration
  var m = document.createElement('div')
  m.innerHTML = msg
  m.style.cssText = 'padding:0px 20px;height: 30px;color: rgb(255, 255, 255);line-height: 30px;text-align: center;border-radius: 15px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 14px;'

  document.body.appendChild(m)
  setTimeout(function () {
    var d = 0.5
    m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in'
    m.style.opacity = '0'
    setTimeout(function () { document.body.removeChild(m) }, d * 1000)
  }, duration)
}
